import { render, staticRenderFns } from "./SnippetForm.vue?vue&type=template&id=b7f5a398&"
import script from "./SnippetForm.vue?vue&type=script&lang=ts&"
export * from "./SnippetForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports